export const REMOTE = {
  V1_ON_DRILL: '/v1/onDrill',
  V1_ON_FRAME_SIZE_CHANGE: '/v1/onFrameSizeChange',
  V1_ON_FILTERS_CHANGE: '/v1/onFiltersChange',
};

export const LOCAL = {
  V1_FILTERS_APPLY: '/v1/filters/apply',
  V1_ON_FRAME_SIZE_CHANGE: '/v1/onFrameSizeChange',
};
